import React, { useEffect, type ErrorInfo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from './Loading';

export class ErrorBoundary extends React.Component<
  Record<string, unknown>,
  { hasError: boolean }
> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.onUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.onUnhandledRejection);
  }

  onUnhandledRejection = (event: PromiseRejectionEvent) => {
    event.promise.catch(() => {
      this.setState(ErrorBoundary.getDerivedStateFromError());
    });
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Unexpected error occurred!', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <InitCurrentPage />;
    }

    return this.props.children as React.ReactElement;
  }
}

const InitCurrentPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ search: '' }, { replace: true });
    window.location.reload();
  }, [navigate]);

  return <Loading />;
};
